import PaymentComp from "../../components/payment/PaymentComp";

function Payment() {

  return (
    <PaymentComp/>
  );
}

export default Payment;